import { IResultSbCampaigns } from "../../types/sbCampaignApi.types"
import { ISbTargetDataForTable } from "../../types/sbTarget.types"
import { ISbTargetResult } from "../../types/sbTargetApi.types"

export enum SponsoredBrandsActionType {
  FETCH_SPONSORED_BRANDS_CAMPAIGNS = "FETCH_SPONSORED_BRANDS",
  FETCH_SPONSORED_BRANDS_CAMPAIGNS_SUCCESS = "FETCH_SPONSORED_BRANDS_SUCCESS",
  FETCH_SPONSORED_BRANDS_CAMPAIGNS_ERROR = "FETCH_SPONSORED_BRANDS_ERROR",
  FETCH_SPONSORED_BRANDS_TARGETS = "FETCH_SPONSORED_BRANDS_TARGETS",
  FETCH_SPONSORED_BRANDS_TARGETS_SUCCESS = "FETCH_SPONSORED_BRANDS_TARGETS_SUCCESS",
  FETCH_SPONSORED_BRANDS_TARGETS_ERROR = "FETCH_SPONSORED_BRANDS_TARGETS_ERROR",
  UPDATE_SPONSORED_BRANDS_TARGETS_LOCAL = "UPDATE_SPONSORED_BRANDS_TARGETS_LOCAL",
  ADD_SPONSORED_BRANDS_TARGETS = "ADD_SPONSORED_BRANDS_TARGETS",
  RESET_SPONSORED_BRANDS_TARGETS = "RESET_SPONSORED_BRANDS_TARGETS",
}

interface FetchSponsoredBrands {
  type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS
}

interface FetchSponsoredBrandsSuccess {
  type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS_SUCCESS
  payload: IResultSbCampaigns
}

interface FetchSponsoredBrandsError {
  type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS_ERROR
  payload: string
}

interface FetchSponsoredBrandsTargets {
  type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS
  payload: { campaignIds: string[]; generation: number }
}

interface FetchSponsoredBrandsTargetSuccess {
  type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS_SUCCESS
  payload: { campaignIds: string[]; targets: ISbTargetResult[]; generation: number }
}

interface FetchSponsoredBrandsTargetError {
  type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS_ERROR
  payload: { campaignIds: string[]; error: string; generation: number }
}

interface UpdateSponsoredBrandsTargetsLocal {
  type: SponsoredBrandsActionType.UPDATE_SPONSORED_BRANDS_TARGETS_LOCAL
  payload: ISbTargetDataForTable[]
}

interface AddSponsoredBrandsTargets {
  type: SponsoredBrandsActionType.ADD_SPONSORED_BRANDS_TARGETS
  payload: ISbTargetDataForTable[]
}

interface ResetSponsoredBrandsTargets {
  type: SponsoredBrandsActionType.RESET_SPONSORED_BRANDS_TARGETS
}

export type SponsoredBrandsAction =
  | FetchSponsoredBrands
  | FetchSponsoredBrandsSuccess
  | FetchSponsoredBrandsError
  | FetchSponsoredBrandsTargets
  | FetchSponsoredBrandsTargetSuccess
  | FetchSponsoredBrandsTargetError
  | UpdateSponsoredBrandsTargetsLocal
  | AddSponsoredBrandsTargets
  | ResetSponsoredBrandsTargets

export interface SponsoredBrandsState {
  campaignData: IResultSbCampaigns
  loading: boolean
  error: null | string
}

export interface SponsoredBrandsTargetState {
  targetData: ISbTargetResult[]
  loading: boolean
  error: null | string
  pendingCampaignIds: string[]
  failedCampaignIds: string[]
  requestGeneration: number
}

export interface SponsoredBrandsTargetForTableState {
  targetDataForTable: ISbTargetDataForTable[]
}
